import { Component } from "@angular/core";

/**
 * Generic container that constrains page content width.
 */
@Component({
  selector: "bit-container",
  templateUrl: "container.component.html",
  standalone: true,
})
export class ContainerComponent {}
